import { useQuery } from "@tanstack/react-query";

import { listarCotizacionItemsRequest } from "@/lib/cotizacionContenido";

/**
 * El catálogo de ítems con que se arman Metodología y Documentación.
 *
 * `staleTime` largo a propósito: son datos maestros que cambian cuando alguien
 * entra al mantenedor, no durante una sesión de cotización. Refetchearlos en
 * cada foco de ventana sería una consulta por nada mientras se llena un
 * formulario.
 */
export function useCotizacionItems() {
  return useQuery({
    queryKey: ["cotizacion-items"],
    queryFn: listarCotizacionItemsRequest,
    staleTime: 5 * 60 * 1000,
  });
}
